package ui.app.rss.channel


import androidx.compose.runtime.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.app.rss.channel.AppRssListingChannelVM.Action
import ui.user.UserListingScope.Wrapper
import ui.widget.*
import kotlin.time.Duration.Companion.days
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.milliseconds

@Stable
data class AppRssListingChannelScope(
    val nav: Navigation,
    val vm: AppRssListingChannelVM,
    val action: (Action) -> Unit
) {
    companion object {
        @Composable
        fun remember(): AppRssListingChannelScope {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(AppRssListingChannelVM::class)
            val action = Action.rememberAction(vm)
            return remember {
                AppRssListingChannelScope(
                    nav = nav,
                    vm = vm,
                    action = action
                ).also {
                    vm.init(it)
                }
            }
        }


        val headerSpecs = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_channels_listing__id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_channels_listing__alias, width = 150.dp) { it.data.name },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_channels_listing__url, width = 350.dp) { it.data.url },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_channels_listing__last_update, width = 120.dp) { it.data.dtLast.formatFromRes() },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_channels_listing__update_interval, width = 100.dp) { it.data.intervalMs.milliseconds }
        )
    }

    class Wrapper(
        listing: Io.ListingRssChannel
    ) : EFieldList<Io.ListingRssChannel.Item, Wrapper.Item>(
        items = listing.items,
        onBindEntry = { Item(it) }
    ) {
        class Item(
            override val data: Io.ListingRssChannel.Item,
            override val key: String = data.id.toString(),
        ) : Entry<Io.ListingRssChannel.Item> {

            val name = EFieldTextValue(
                property = data::name,
                condition = {
                    it.trim().takeIf { it.isNotEmpty() }
                })

            val url = EFieldTextValue(
                property = data::url,
                condition = {
                    it.trim().takeIf { it.startsWith("http://") || it.startsWith("https://") }
                })

            val interval = EFieldRegularLong(data::intervalMs)

            companion object {
                val intervals by lazy {
                    listOf(
                        1.hours,
                        2.hours,
                        4.hours,
                        6.hours,
                        12.hours,
                        1.days,
                        2.days,
                    )
                }
            }
        }
    }
}
